// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WIKI_PHOTO_FROM_REVIEW_BY_nick = "Ze zku\u0161enosti od %(nick)s";
export const WIKI_PHOTO_ORIGIN_MANUFACTURER = "WIKI_PHOTO_ORIGIN_MANUFACTURER";
export const WIKI_PHOTO_SHOW_REVIEW = "Zobrazit zku\u0161enost";
